(() => {
  let prevScrollPos = window.scrollY;
  const additionalMenuWrapper = document.querySelector(".header__additionalMenuWrapper");

  window.onscroll = function() {
    const currentScrollPos = window.scrollY;

    if (currentScrollPos == 0 || currentScrollPos < prevScrollPos) {
      additionalMenuWrapper.classList.remove('header__additionalMenuWrapper--hidden');
    } else {
      additionalMenuWrapper.classList.add('header__additionalMenuWrapper--hidden');
    }

    prevScrollPos = window.scrollY;
  };
})();
